import { createFileRoute, redirect, Outlet } from '@tanstack/react-router';
import { Box } from '@mui/material';

import { useOptimisticUpdates } from '@hooks';
import { useAuthStore } from '@features/auth';
import { NavigationBar } from '@components';

const LayoutComponent = () => {
  useOptimisticUpdates();
  return (
    <>
      <NavigationBar />
      <Box sx={{ height: '100%', paddingTop: 20 }}>
        <Outlet />
      </Box>
    </>
  );
};

export const Route = createFileRoute('/_artworks')({
  beforeLoad: async ({ location }) => {
    const accessToken = useAuthStore.getState().accessToken;
    const isStaff = useAuthStore.getState().isStaff;
    console.log('Auth Route - isStaff:', isStaff);
    if (accessToken && isStaff) {
      throw redirect({
        to: '/staff',
      });
    }
    if (!accessToken) {
      throw redirect({
        to: '/auth',
        search: {
          // Use the current location to power a redirect after login
          // (Do not use `router.state.resolvedLocation` as it can
          // potentially lag behind the actual current location)
          redirect: location.href,
        },
      });
    }
  },
  component: LayoutComponent,
});
